import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, LOCALE_ID,APP_INITIALIZER, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationConstants } from './shared/services/util/translation.constants';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { AccountModule } from './account/account.module';
import { LayoutModule } from './shared/layout/layout.module';
import { HomeModule } from './home/home.module';
import { CreditLetterModule } from './credit-letter/credit-letter.module';
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { JwtInterceptor } from './interceptors/jwt.interceptor';

registerLocaleData(ptBr);

/**
 * Custom HTTP language loader
 *
 * @param httpClient The httpClient
 */
export function LangHttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(httpClient, './../i18n/', '.json');
}

@NgModule({
    declarations: [ AppComponent ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: LangHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AccountModule,
        LayoutModule,
        HomeModule,
        CreditLetterModule
    ],
    providers: [
        TranslationConstants,
        { provide: LOCALE_ID, useValue: 'pt-br' },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },

        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
              showDialog: false,
            }),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
          },
        Title,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
